// Central content + imagery for the ITO public marketing site.
// STRICT: machinery, defence equipment, tanks, ODC and Indian air cargo only.
// NO ports / shipping containers anywhere.

export const SINCE = 1972;

export const USPS = ["Fastest", "Safest", "Most reliable", "Trusted nationwide"];

export const CONTACT = {
  phone: "8492894602",
  phoneHref: "tel:+918492894602",
  email: "transport@itoengginfra.com",
  emailHref: "mailto:transport@itoengginfra.com",
  whatsappHref: "https://wa.me/918492894602",
  address: "313, Mohid Heights, RTO Lane, Andheri West, Mumbai 400053",
  mapQuery: "Mohid Heights, Suresh Nagar, Andheri West, Mumbai 400053",
};

// ALL imagery is Indian-context only (generated or Indian stock). No ports / containers.
const CDN = "https://static.prod-images.emergentagent.com/jobs/27de4b5e-8074-4d81-9f3d-4b15e68f94e6/images/";
export const IMAGES = {
  // Indian stock
  heroHighway:
    "https://images.pexels.com/photos/5774277/pexels-photo-5774277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  reeferTruck:
    "https://static.prod-images.emergentagent.com/jobs/9cbd5b9e-f8ce-4d41-86d0-1a1eddd399f3/images/ed9fdb0891f516ed6feb90583a027ba8ceefc04162de7f5c5f19a1fd7a94f557.jpeg",
  heroTruck:
    "https://images.unsplash.com/photo-1635774152029-17bf0a3e1cb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ruralTruck:
    "https://images.unsplash.com/photo-1681004478577-cb7f8421f78c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  parcel:
    "https://images.unsplash.com/photo-1643194928491-dbc706a8c53e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse:
    "https://images.unsplash.com/photo-1706186101257-818a4bbfd8bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  defenceTankReal:
    "https://images.unsplash.com/photo-1585802540432-60662b65ca62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  // Generated Indian-context (photorealistic, unbranded — no company logos/text)
  odcTransformer: CDN + "26bf78e5ee64aee26ee5c97f85a51051feef20c28756bafbc03cd84c9cce5b73.jpeg",
  odcExcavator: CDN + "9f43708f318b9b5723cab28c60281b19e72b81dc295094c4eca4a66bc8e81cf5.jpeg",
  airSuspension: CDN + "a5b4ec89e65f195932d357299aed256acf662458425b67d30cb7824816589b13.jpeg",
  explosiveVan: CDN + "2a1844724cb207ace45856673bb8cd79db9c52229f81de05145d6bcfb77dcb5d.jpeg",
  tankTrailer: CDN + "5b1618db4bafeba8eeba603853d8095359152340a7defe6462f2f141ab04ac0e.jpeg",
  defenceDrone: CDN + "bc5080c9cfe87ac171fac5c71b3934fc591b4833b69eaf72e85bfe3c3958b7d9.jpeg",
  airCargo: CDN + "bb66a4dde7cf71ebdd0b3a80398bfeb9ec57763347ab7ab4bd1e2917015b7b83.jpeg",
  fleetYard: CDN + "70dbf3f5aa5de56cca63c3b182c96a26c690721362e4da84b25679db40f37bad.jpeg",
  lehConvoy: CDN + "914ff05a9e5213c8e2458f1e1892dd462941d4633166061679b8357d87d98097.jpeg",
  industrialTank: CDN + "9fecdc47544e44c14eb5051aec0091a11086cf8ec2fbe757b538946536e2c8af.jpeg",
  chemicalTank: CDN + "bb01586d6391106afbb453a9cbfc641706aafa350dbf692a9d61e3dfe591c240.jpeg",
  blogBanner: CDN + "5cb69634a830e43d9dfd39739089cdc7439fc93916c798751f91a01e41aaf275.jpeg",
  aeroEngine: "https://static.prod-images.emergentagent.com/jobs/9cbd5b9e-f8ce-4d41-86d0-1a1eddd399f3/images/8a1148d1340685cf29008659c273591860343c7edd66b62f0d0644cae4c79c35.jpeg",
  aeroShop: "https://static.prod-images.emergentagent.com/jobs/9cbd5b9e-f8ce-4d41-86d0-1a1eddd399f3/images/2dae769aed4e5a90b66f831ad7c1541c6025e80ce9b8cfe113e8ba883cbe8f6b.jpeg",
};

export const STATS = [
  { value: 800, suffix: "+", label: "Own fleet vehicles" },
  { value: 23, suffix: "+", label: "Offices across India" },
  { value: 2500, suffix: "+", label: "Staff on the ground" },
  { value: 19000, suffix: "+", label: "Delivery pincodes served" },
];

// SEO-rich fleet catalogue — air-suspension trailers & explosive vans emphasised.
export const FLEET = [
  {
    icon: "Wind", slug: "air-suspension-trailer", img: "airSuspension",
    name: "Air-suspension trailers",
    desc:
      "Our pneumatic air-suspension trailers cushion road shock and vibration to protect fragile, calibration-critical and high-value cargo — aero engines and aerospace assemblies, CNC machines, transformers, electronics and defence electro-optics. When you need the smoothest ride on Indian roads, our air suspension trailers deliver damage-free transport, every kilometre.",
    bestFor: ["Aero engines & aerospace assemblies", "CNC & precision machines", "Transformers & electronics", "Defence electro-optics"],
  },
  {
    icon: "ShieldAlert", slug: "explosive-van", img: "explosiveVan",
    name: "Explosive vans",
    desc:
      "Purpose-built, licensed explosive vans for the safe movement of ammunition, explosives and hazardous defence stores. Our explosive vans are fire-suppression fitted, escort-ready and fully compliant with Indian explosives and defence transport regulations — the safest way to move Class-1 dangerous goods across India.",
    bestFor: ["Ammunition & explosives", "Class-1 dangerous goods", "Hazardous defence stores", "Escort-ready movements"],
  },
  {
    icon: "Layers", slug: "low-bed-trailer", img: "odcExcavator",
    name: "Low-bed trailers",
    desc:
      "Low-bed (lowboy) trailers for tall, heavy plant — excavators, cranes, transformers and armoured vehicles — with a low deck height for safe, stable ODC movement.",
    bestFor: ["Excavators & cranes", "Transformers", "Armoured vehicles", "Tall ODC loads"],
  },
  {
    icon: "Layers", slug: "semi-low-bed-trailer", img: "odcExcavator",
    name: "Semi low-bed trailers",
    desc:
      "Semi low-bed trailers balancing deck height and payload for medium-heavy over-dimensional consignments.",
    bestFor: ["Medium-heavy ODC", "Machinery", "Balanced deck & payload"],
  },
  {
    icon: "Layers", slug: "high-bed-trailer", img: "fleetYard",
    name: "High-bed trailers",
    desc:
      "High-bed flatbed trailers for steel, fabricated structures, machinery and general full-truck-load cargo.",
    bestFor: ["Steel & structures", "Machinery", "Full-truck-load cargo"],
  },
  {
    icon: "Cog", slug: "modular-heavy-haul-trailer", img: "odcTransformer",
    name: "Modular heavy-haul trailers",
    desc:
      "Modular axle-line and self-propelled trailers for the heaviest single-piece over-dimensional and over-weight loads.",
    bestFor: ["Heaviest single-piece loads", "Over-weight ODC", "Self-propelled movement"],
  },
  {
    icon: "Truck", slug: "trucks-open-closed-body", img: "fleetYard",
    name: "Trucks — open & closed body",
    desc:
      "12, 14, 18 and 22-tyre trucks for full and part loads to every industrial corridor in India.",
    bestFor: ["Full & part loads", "Industrial corridors", "Open & closed body"],
  },
  {
    icon: "Snowflake", slug: "reefer-vehicles", img: "reeferTruck",
    name: "Reefer vehicles (all sizes)",
    desc:
      "Temperature-controlled reefer trucks in every size, reserved for temperature-sensitive defence, aerospace and chemical cargo. We move propellants and sensitive chemicals, cold-stored composite resins and prepregs, defence electro-optics and sensitive electronics, adhesives, sealants and specialty coatings, and aero-engine components that need a controlled temperature. The set point is held and monitored from pickup to delivery, anywhere in India.",
    bestFor: [
      "Temperature-sensitive chemicals & propellants",
      "Composite resins & prepregs (cold-stored)",
      "Defence electro-optics & sensitive electronics",
      "Adhesives, sealants & specialty coatings",
      "Aero-engine components needing controlled temperature",
    ],
  },
  {
    icon: "PackageSearch", slug: "tempos-city-vehicles", img: "fleetYard",
    name: "Tempos & city vehicles",
    desc:
      "Tempos and small commercial vehicles for nimble first-mile pickup and last-mile delivery inside cities.",
    bestFor: ["First & last mile", "City delivery", "Small consignments"],
  },
];

export const FLEET_GALLERY = {
  "air-suspension-trailer": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/58b7702987c8ab22aa70d77019e279800f24a08a5fa335760a428875e50add82.jpeg",
  ],
  "explosive-van": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/753b4bae0242101d81d924171d11908a5b1a377962593097d2360addbe2bd950.jpeg",
  ],
  "low-bed-trailer": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/f3b585cffe97a120a0eaeb178be134928b9f424ef4ff8c43c5e2322ec5a113f0.jpeg",
  ],
  "semi-low-bed-trailer": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/af4e055059e8aad5b9f0e9b3a097fe7c706db4a92b2444c978aeb69126dbae8f.jpeg",
  ],
  "high-bed-trailer": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/043ec6fc11a04c3abc271428491f45252e2ec778df10d60771d540c6a6e8865f.jpeg",
  ],
  "modular-heavy-haul-trailer": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/80bae95b3c9bbc8ec505139518741baec68f5fc1d82373ef948bc1dce57ace5f.jpeg",
  ],
  "trucks-open-closed-body": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/3f687536815660200fae0246fbcdbb0c4c92fa54ac5c04a0edfa5e878c085fa7.jpeg",
  ],
  "reefer-vehicles": [
    "https://static.prod-images.emergentagent.com/jobs/9cbd5b9e-f8ce-4d41-86d0-1a1eddd399f3/images/ed9fdb0891f516ed6feb90583a027ba8ceefc04162de7f5c5f19a1fd7a94f557.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/9cbd5b9e-f8ce-4d41-86d0-1a1eddd399f3/images/87037f6b4ed7be712bc31328a0ac21d8406d657183de69fa259e2b1ee7725209.jpeg",
  ],
  "tempos-city-vehicles": [
    "https://static.prod-images.emergentagent.com/jobs/4d98596c-69ef-4275-af20-3c3cfe5d7c8c/images/0e214a416c7fd34e1cc58ee5929d8b5d7b6add6cfd04f7c389be3986d3074cda.jpeg",
  ],
};

export const DEFENCE = {
  title: "A trusted logistics partner to Indian defence.",
  body:
    "ITO moves for the Indian defence ecosystem day in, day out — battle tanks and armoured hulls, artillery and gun systems, drones and UAV assemblies, radar and electro-optic equipment, and ammunition in licensed explosive vans. Every defence movement is sealed, escorted, route-surveyed, permitted and documented to defence-grade standards.",
  points: [
    "Battle tanks & armoured vehicles",
    "Drones & UAV systems",
    "Artillery, radar & electro-optics",
    "Ammunition in licensed explosive vans",
  ],
};

export const SERVICES = [
  {
    slug: "full-truck-load",
    tag: "FTL",
    title: "Full Truck Load",
    short:
      "Dedicated single-consignment vehicles for machinery, plant equipment and defence stores — sealed, direct, no touch in transit.",
    image: IMAGES.airSuspension,
    icon: "Truck",
    hero:
      "One consignment. One vehicle. Straight from your plant gate to the destination — no transhipment, no mix-ups.",
    intro:
      "Our FTL fleet is built for industrial and defence cargo — from construction machinery and gensets to armoured hulls and turret assemblies. Every vehicle runs point-to-point with a sealed body and a single accountable driver crew.",
    features: [
      { h: "Sealed direct movement", p: "Cargo is loaded once and stays sealed until delivery — critical for defence equipment and precision machinery." },
      { h: "Air-suspension trailers", p: "Air-suspension trailers cushion road shock for sensitive, calibration-critical and electronic machinery — damage-free transit, every kilometre." },
      { h: "Heavy-haul capacity", p: "12-tyre, 14-tyre, 18-tyre and 22-tyre rigs sized to the exact weight of your load." },
      { h: "Live LR tracking", p: "Every Lorry Receipt is trackable by pincode — your consignee gets a live status link." },
    ],
    cargo: ["Defence equipment", "Construction machinery", "CNC & machine tools", "Gensets & transformers"],
  },
  {
    slug: "part-load-parcel",
    tag: "LTL",
    title: "Part Load & Parcel",
    short:
      "Share-a-truck economics for smaller machinery spares, defence sub-assemblies and documents — with the same tracking discipline as FTL.",
    image: IMAGES.parcel,
    icon: "PackageSearch",
    hero:
      "Not every shipment fills a trailer. Move part loads and parcels across India without paying for empty space.",
    intro:
      "Our LTL network consolidates part loads onto scheduled line-haul routes, so a single crate of spares or a pallet of components rides economically alongside compatible cargo — never near hazardous or contaminating goods.",
    features: [
      { h: "Pay for what you ship", p: "Rated by weight and volume — ideal for spares, tooling and sub-assemblies." },
      { h: "Scheduled line-haul", p: "Fixed departure lanes between major industrial hubs for predictable transit." },
      { h: "Safe consolidation", p: "Machinery and defence parcels are segregated from any incompatible cargo." },
      { h: "Doorstep to every pincode", p: "Last-mile delivery to plant gates and depots across India." },
    ],
    cargo: ["Defence equipment", "Construction machinery spares", "Machine spares & tooling", "Crated components"],
  },
  {
    slug: "warehousing",
    tag: "Warehousing",
    title: "Warehousing & Handling",
    short:
      "Secured storage, staging and mechanised handling for heavy machinery and defence consignments between plant and site.",
    image: IMAGES.warehouse,
    icon: "Warehouse",
    hero:
      "Store, stage and handle heavy cargo safely — with forklifts, cranes and secured yards built for industrial weights.",
    intro:
      "When cargo needs to wait — for a site to be ready, a convoy to form, or an inspection to clear — our warehouses provide covered and open-yard storage with mechanised handling and 24×7 security.",
    features: [
      { h: "Heavy-duty handling", p: "Forklifts, gantry cranes and heavy-lift equipment for loading and unloading heavy machinery." },
      { h: "Secured yards", p: "Fenced, lit and guarded open yards for ODC consignments and rolling stock." },
      { h: "Staging & convoy build-up", p: "Marshal multiple loads before a coordinated project or defence movement." },
      { h: "Inventory visibility", p: "Every stored item is logged and retrievable against your consignment." },
    ],
    cargo: ["Defence equipment", "Construction machinery", "ODC modules", "Project cargo staging"],
  },
  {
    slug: "air-express-cargo",
    tag: "Air",
    title: "Air & Express Cargo",
    short:
      "Domestic Indian air cargo for time-critical machinery spares and defence priority stores — booked, uplifted and tracked.",
    image: IMAGES.airCargo,
    icon: "Plane",
    hero:
      "When a line is down or a unit is grounded, hours matter. Move it by air, across India, today.",
    intro:
      "We book and uplift priority cargo on domestic Indian air freighters and belly-hold capacity — the fastest way to get an AOG spare, an aero-engine module, a critical machine part or priority defence stores where they are needed.",
    features: [
      { h: "Same-day / next-flight-out", p: "Priority uplift on domestic Indian sectors for grounded machinery and AOG spares." },
      { h: "Airport-to-door", p: "Surface pickup, airport handling and last-mile delivery stitched into one LR." },
      { h: "Priority defence stores", p: "Time-critical movement of authorised defence consignments across the country." },
      { h: "End-to-end tracking", p: "One reference from pickup, through uplift, to final delivery." },
    ],
    cargo: ["Defence equipment", "Construction machinery spares", "AOG & critical spares", "Precision instruments"],
  },
  {
    slug: "project-odc-cargo",
    tag: "ODC",
    title: "Project, Heavy & ODC Cargo",
    short:
      "Over-dimensional movements — battle tanks, industrial & chemical storage tanks, turbines, transformers and plant modules — engineered end to end.",
    image: IMAGES.odcTransformer,
    icon: "Container",
    hero:
      "The loads other transporters turn away. Battle tanks, industrial & chemical tanks, transformers and plant modules — surveyed, permitted and delivered, even to Leh.",
    intro:
      "This is where ITO leads. We move over-dimensional and over-weight cargo with specialised low-bed and modular trailers, route surveys, permits and pilot escorts — the discipline demanded by defence, oil & gas, chemical and heavy-industry movements. That includes battle tanks for defence and huge industrial & chemical storage tanks, pressure vessels and reactors for refineries and process plants. From plant gates to the highest border regions, we deliver where others cannot.",
    features: [
      { h: "Route survey & permits", p: "We survey the road, secure state permits and clear obstructions before the load rolls." },
      { h: "Low-bed & modular trailers", p: "High-, low- and semi low-bed and modular trailers for the heaviest single pieces." },
      { h: "Pilot & escort convoy", p: "Pilot vehicles, police and army escort coordination and night-movement planning." },
      { h: "Border & high-altitude reach", p: "Proven ODC movements into Leh, Ladakh and the Himalayan border regions for defence and infrastructure." },
    ],
    cargo: ["Battle tanks & armoured vehicles", "Industrial & chemical tanks", "Transformers & turbines", "Construction machinery"],
  },
  {
    slug: "pan-india-network",
    tag: "Network",
    title: "Pan-India Network",
    short:
      "Pickup and delivery to & from every pincode in India — one accountable partner from Kashmir to Kanyakumari.",
    image: IMAGES.ruralTruck,
    icon: "MapPinned",
    hero:
      "Every pincode. Every corridor. One partner accountable from origin to destination.",
    intro:
      "Our network reaches plant gates, defence depots and project sites in every corner of the country. Whether it moves by road or by air, you get a single Lorry Receipt and a single point of accountability.",
    features: [
      { h: "Every-pincode reach", p: "Pickup and delivery across all states and union territories of India." },
      { h: "Road + air, one LR", p: "Seamlessly switch between road and air on a single tracked consignment." },
      { h: "Regional hubs", p: "Handling and consolidation hubs across major industrial corridors." },
      { h: "One accountable partner", p: "No hand-off blind spots — ITO owns the shipment end to end." },
    ],
    cargo: ["Defence depot network", "Construction machinery", "Nationwide FTL & LTL", "Plant-to-site corridors"],
  },
];

// Standalone Defence page (not shown in the 6-card grid, but a real /services/ route).
export const DEFENCE_SERVICE = {
  slug: "defence-logistics",
  tag: "Defence",
  title: "Defence & Government Logistics",
  short:
    "A trusted transport partner to Indian defence — tanks, drones, artillery, radar and ammunition in licensed explosive vans, moved sealed and escorted nationwide.",
  image: IMAGES.tankTrailer,
  icon: "ShieldCheck",
  hero:
    "Battle tanks, drones and ammunition — moved for the Indian defence ecosystem with sealed, escorted, defence-grade discipline.",
  intro:
    "ITO moves for the Indian defence ecosystem day in, day out — armoured vehicles and battle tanks, drones and UAV assemblies, artillery and gun systems, radar and electro-optic equipment, and ammunition in licensed explosive vans. Every movement is sealed, route-surveyed, permitted, escorted and documented to defence-grade standards, right up to the highest border regions.",
  features: [
    { h: "Licensed explosive vans", p: "Fire-suppression fitted, escort-ready vans for the compliant movement of ammunition and hazardous defence stores." },
    { h: "Tanks & armoured vehicles", p: "Low-bed and modular trailers with chaining, escorts and route surveys for battle tanks and hulls." },
    { h: "Drones, radar & electro-optics", p: "Shock-protected, air-suspension transit for sensitive UAV, radar and electro-optic equipment." },
    { h: "Border & high-altitude reach", p: "Proven movements to Leh, Ladakh and forward areas in the Himalayan border regions." },
  ],
  cargo: ["Battle tanks & armoured vehicles", "Drones & UAV systems", "Artillery, radar & electro-optics", "Ammunition in explosive vans"],
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Fleet", to: "/fleet" },
  { label: "Defence", to: "/defence" },
  { label: "Aerospace", to: "/aerospace" },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const serviceBySlug = (slug) =>
  [...SERVICES, DEFENCE_SERVICE].find((s) => s.slug === slug);

// Per-service SEO (unique keyword-rich title + description for each page).
export const SERVICE_SEO = {
  "full-truck-load": {
    title: "Full Truck Load (FTL) Transport in India | Air-Suspension Trailers — ITO",
    description:
      "Dedicated full truck load (FTL) transport across India with air-suspension trailers and heavy-haul trucks for machinery, defence equipment and construction machinery. Sealed, direct, live-tracked. Since 1972.",
  },
  "part-load-parcel": {
    title: "Part Load & Parcel (LTL) Transport in India | Cargo Transportation — ITO",
    description:
      "Economical part load and parcel (LTL) cargo transportation across India for machinery spares, defence sub-assemblies and components — scheduled line-haul to every pincode.",
  },
  warehousing: {
    title: "Warehousing & Cargo Handling in India | Heavy Machinery Storage — ITO",
    description:
      "Secured warehousing, staging and mechanised handling for heavy machinery, ODC and defence cargo in India — forklifts, cranes, guarded yards and full inventory visibility.",
  },
  "air-express-cargo": {
    title: "Domestic Air Cargo in India | Express Freight & AOG Spares — ITO",
    description:
      "Fast domestic air cargo across India for time-critical machinery spares, AOG parts and priority defence stores — airport-to-door on a single tracked consignment.",
  },
  "project-odc-cargo": {
    title: "ODC & Over-Dimensional Cargo Transport in India | Tank & Heavy Haulage — ITO",
    description:
      "India's ODC transporter for over-dimensional and over-weight cargo — tanks, transformers, oil & gas modules and construction machinery. Specialised low-bed and modular trailers, permits and escorts, even to Leh. Since 1972.",
  },
  "pan-india-network": {
    title: "Pan-India Transporter | Cargo to Every Pincode by Road & Air — ITO",
    description:
      "A pan-India transporter delivering cargo to and from every pincode by road and air — one accountable partner from Kashmir to Kanyakumari, including Leh and border regions.",
  },
  "defence-logistics": {
    title: "Defence Logistics in India | Tank, Drone & Explosive Van Transport — ITO",
    description:
      "Trusted defence logistics in India since 1972 — battle tanks, drones, artillery, radar and ammunition in licensed explosive vans, moved sealed and escorted to every pincode, including Leh and border regions.",
  },
};

// Visible on-page SEO term cloud (real content ranks better than meta alone).
export const SEO_TERMS = [
  "Air suspension trailer in India",
  "Explosive van transport India",
  "Transporter in India",
  "Cargo transportation company",
  "ODC transporter India",
  "Over-dimensional cargo transport",
  "Heavy haulage India",
  "Low-bed & semi low-bed trailers",
  "Modular heavy-haul trailers",
  "Oil & gas project cargo",
  "Industrial & chemical tank transport",
  "Defence cargo & tank transport",
  "Drone & UAV transport",
  "Aero engine transport India",
  "Aerospace logistics India",
  "Temperature-controlled chemical transport",
  "Reefer transport for defence material",
  "Construction machinery transport",
  "Project cargo India",
  "Domestic air cargo India",
  "Full truck load (FTL)",
  "Part load & parcel (LTL)",
  "Warehousing & handling",
  "Pan-India logistics network",
  "Leh & Ladakh cargo transport",
  "Mumbai transporter since 1972",
];

// ---------------------------------------------------------------------------
// Structured-data helpers (JSON-LD) + FAQ content used across all pages.
// AI answer engines (Google AI Overviews, Gemini) and rich results lean heavily
// on FAQPage + BreadcrumbList, so every page ships both.
// ---------------------------------------------------------------------------
export const SITE = "https://itoworldwide.com";

export const ORG_NODE = {
  "@type": "MovingCompany",
  "@id": `${SITE}/#organization`,
  name: "Indian Transport Organisation",
  alternateName: "ITO",
  url: `${SITE}/`,
  logo: `${SITE}/ito-logo.png`,
  telephone: "+91-8492894602",
  email: CONTACT.email,
  foundingDate: "1972",
  areaServed: "IN",
  address: {
    "@type": "PostalAddress",
    streetAddress: "313, Mohid Heights, RTO Lane, Andheri West",
    addressLocality: "Mumbai",
    addressRegion: "MH",
    postalCode: "400053",
    addressCountry: "IN",
  },
};

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (faqs || []).map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

// Homepage FAQ (targets high-intent "who / best / where" questions).
export const HOME_FAQ = [
  {
    q: "Who is a trusted transporter for heavy and over-dimensional cargo in India?",
    a: "Indian Transport Organisation (ITO) has been one of India's most trusted heavy-haul and ODC transporters since 1972, with 800+ owned vehicles, 23+ offices and 2,500+ staff. We move machinery, transformers, tanks, defence equipment and oil & gas modules to every pincode in India, including Leh and border regions.",
  },
  {
    q: "Which types of trailers and trucks does ITO operate?",
    a: "Our 800+ owned fleet includes air-suspension trailers, licensed explosive vans, low-bed, semi low-bed and high-bed trailers, modular heavy-haul trailers, 12–22 tyre open and closed-body trucks, and city tempos — matched to the exact weight and dimensions of your cargo.",
  },
  {
    q: "Does ITO deliver to every pincode in India?",
    a: "Yes. We pick up and deliver to and from every pincode in India by road and air on a single Lorry Receipt, from Kashmir to Kanyakumari, including high-altitude routes to Leh and Ladakh.",
  },
  {
    q: "How do I get a freight quote from ITO?",
    a: `Call us on ${CONTACT.phone} or email ${CONTACT.email} with your cargo type, weight, dimensions, pickup and delivery locations, and our team will quote your movement quickly.`,
  },
];

export const FLEET_INDEX_FAQ = [
  {
    q: "How large is Indian Transport Organisation's fleet?",
    a: "ITO owns and operates 800+ vehicles across India — from city tempos to modular heavy-haul trailers — so we can match the exact vehicle your cargo needs rather than relying only on brokered trucks.",
  },
  {
    q: "Which trailer is best for sensitive or precision machinery?",
    a: "Air-suspension trailers are best for fragile, calibration-critical and high-value cargo such as CNC machines, transformers, electronics and defence electro-optics, because they cushion road shock and vibration.",
  },
  {
    q: "Do you have licensed vehicles for explosives and defence stores?",
    a: "Yes. We run licensed, fire-suppression fitted explosive vans for ammunition and hazardous defence stores, fully compliant with Indian explosives and defence transport regulations.",
  },
];

export const ABOUT_FAQ = [
  {
    q: "How long has Indian Transport Organisation been operating?",
    a: "ITO has been moving India's heaviest and most critical cargo since 1972 — over five decades of ODC, heavy-haul, defence and air-cargo experience.",
  },
  {
    q: "What kind of cargo does ITO specialise in?",
    a: "We specialise in over-dimensional and over-weight cargo — transformers, turbines, excavators, oil & gas modules, industrial and chemical storage tanks, and battle tanks — on specialised low-bed and modular trailers, route-surveyed and escorted across India.",
  },
];

export const DEFENCE_FAQ = [
  {
    q: "Does ITO transport defence and military cargo in India?",
    a: "Yes. ITO moves for the Indian defence ecosystem daily — battle tanks and armoured hulls, artillery and gun systems, drones and UAV assemblies, radar and electro-optics, and ammunition in licensed explosive vans — all sealed, escorted and documented to defence-grade standards.",
  },
  {
    q: "How is ammunition transported safely?",
    a: "Ammunition and hazardous defence stores move in purpose-built, licensed, fire-suppression fitted explosive vans that are escort-ready and fully compliant with Indian explosives and defence transport regulations.",
  },
  {
    q: "Can you deliver defence cargo to border and high-altitude areas?",
    a: "Yes. We have proven movements to Leh, Ladakh and forward areas in the Himalayan border regions, with route surveys, permits and pilot/army escort coordination.",
  },
];

export const CONTACT_FAQ = [
  {
    q: "Where is Indian Transport Organisation's head office?",
    a: `Our head office is at ${CONTACT.address}. We coordinate movements across all of India from here.`,
  },
  {
    q: "How quickly can ITO arrange a vehicle?",
    a: "Because we own 800+ vehicles, we can usually mobilise the right trailer or truck quickly. Share your cargo details and required dates and our coordinator will confirm availability.",
  },
];

// Per-service FAQ (visible + FAQPage schema on each /services/:slug page).
export const SERVICE_FAQ = {
  "full-truck-load": [
    { q: "What is full truck load (FTL) transport?", a: "FTL means a single dedicated vehicle carries only your consignment, point to point, with no transhipment — ideal for machinery, plant equipment and defence stores that must stay sealed in transit." },
    { q: "Which vehicles does ITO use for FTL?", a: "Air-suspension trailers for sensitive machinery and 12, 14, 18 and 22-tyre trucks sized to your exact load, all from our 800+ owned fleet." },
    { q: "Do you offer FTL to every state in India?", a: "Yes — we run dedicated FTL movements to every pincode in India, with live LR tracking from pickup to delivery." },
  ],
  "part-load-parcel": [
    { q: "What is part load / LTL transport?", a: "Part load (LTL) lets you pay only for the space your cargo uses by riding on scheduled line-haul routes alongside compatible cargo — economical for spares, tooling and sub-assemblies." },
    { q: "Is part-load cargo tracked like FTL?", a: "Yes. Every part-load consignment gets the same Lorry Receipt tracking discipline as a full truck load, to any pincode in India." },
  ],
  warehousing: [
    { q: "Does ITO provide warehousing for heavy machinery?", a: "Yes — we offer covered and open-yard storage with mechanised handling (forklifts, gantry and heavy-lift cranes) and 24×7 secured, guarded yards for ODC and rolling stock." },
    { q: "Can you stage cargo before a project or convoy movement?", a: "Yes. We marshal and stage multiple loads for coordinated project or defence movements, with every stored item logged against your consignment." },
  ],
  "air-express-cargo": [
    { q: "Does ITO offer domestic air cargo in India?", a: "Yes. We book and uplift priority cargo on domestic Indian air freighters and belly-hold capacity — same-day / next-flight-out for grounded machinery, AOG spares and priority defence stores." },
    { q: "Is air cargo delivered door to door?", a: "Yes — surface pickup, airport handling and last-mile delivery are stitched into one tracked Lorry Receipt, airport-to-door." },
  ],
  "project-odc-cargo": [
    { q: "What is ODC / over-dimensional cargo transport?", a: "ODC transport moves loads that exceed standard road dimensions or weight — transformers, turbines, tanks, reactors and battle tanks — on specialised low-bed and modular trailers with route surveys, permits and pilot escorts." },
    { q: "Who is a leading ODC transporter in India?", a: "Indian Transport Organisation is a leading ODC and heavy-haul transporter in India, moving over-dimensional cargo since 1972, including proven movements to Leh and the Himalayan border regions." },
    { q: "Do you handle permits and escorts for ODC movements?", a: "Yes — we survey the route, secure state permits and RTO clearances, and coordinate pilot vehicles and police/army escorts end to end." },
  ],
  "pan-india-network": [
    { q: "Does ITO cover every pincode in India?", a: "Yes. Our network reaches plant gates, defence depots and project sites in every state and union territory, by road and air, on a single accountable Lorry Receipt." },
    { q: "Can you combine road and air on one shipment?", a: "Yes — we seamlessly switch between road and air on a single tracked consignment with one point of accountability from origin to destination." },
  ],
  "defence-logistics": DEFENCE_FAQ,
};

// Per-fleet-vehicle SEO (unique title, description and keywords for each /fleet/:slug page).
export const FLEET_SEO = {
  "air-suspension-trailer": {
    title: "Air Suspension Trailer Transport in India | Aero Engines & CNC — ITO",
    description: "Hire air-suspension trailers in India for aero engines, CNC machines, transformers, electronics and defence electro-optics. Shock-free, live-tracked transport to any pincode since 1972.",
    keywords: "air suspension trailer india, air suspension trailer hire, aero engine transport india, cnc machine transport, transformer transport, vibration free transport, precision machinery transport",
  },
  "explosive-van": {
    title: "Explosive Van Transport in India | Ammunition & Class-1 Cargo — ITO",
    description: "Licensed, fire-suppression fitted explosive vans for ammunition, explosives and Class-1 dangerous goods. Escort-ready and compliant with Indian explosives rules, to any pincode.",
    keywords: "explosive van india, explosive van hire, ammunition transport india, class 1 dangerous goods transport, explosives transport, defence stores transport",
  },
  "low-bed-trailer": {
    title: "Low Bed Trailer Transport in India | Heavy & Tall ODC Loads — ITO",
    description: "Low-bed (lowboy) trailers for excavators, cranes, transformers, battle tanks and tall ODC loads. Route surveys, permits and escorts arranged end to end, anywhere in India.",
    keywords: "low bed trailer india, low bed trailer hire, lowboy trailer transport, excavator transport, tank transport india, odc transport, heavy machinery transport",
  },
  "semi-low-bed-trailer": {
    title: "Semi Low Bed Trailer Transport in India | Medium-Heavy ODC — ITO",
    description: "Semi low-bed trailers for DG sets, construction equipment, medium transformers and fabrications. Balanced deck height and payload with permits and escorts, pan-India.",
    keywords: "semi low bed trailer india, semi low bed trailer hire, dg set transport, construction equipment transport, medium odc transport",
  },
  "high-bed-trailer": {
    title: "High Bed Flatbed Trailer Transport in India | Steel & FTL — ITO",
    description: "High-bed flatbed trailers for steel, pipes, structural fabrications, machinery and full-load industrial cargo across India. Owned fleet, live LR tracking.",
    keywords: "high bed trailer india, flatbed trailer hire, steel transport india, pipe transport, structural fabrication transport, ftl trailer",
  },
  "modular-heavy-haul-trailer": {
    title: "Modular Hydraulic Axle Trailer in India | Heavy Haul & ODC — ITO",
    description: "Modular hydraulic axle-line and self-propelled trailers for the heaviest single pieces: transformers, turbines, reactors and refinery modules. Engineered heavy haul, pan-India.",
    keywords: "modular trailer india, hydraulic axle trailer, heavy haul transport india, transformer transport, reactor transport, over weight cargo, project cargo india",
  },
  "trucks-open-closed-body": {
    title: "Open & Closed Body Truck Hire in India | 12–22 Tyre FTL & LTL — ITO",
    description: "12, 14, 18 and 22-tyre open and closed-body trucks for full and part loads to every industrial corridor in India. Owned fleet with live Lorry Receipt tracking.",
    keywords: "truck hire india, closed body truck, open body truck, 22 tyre truck, full truck load india, part load transport, container body truck",
  },
  "reefer-vehicles": {
    title: "Reefer Trucks for Defence, Aerospace & Chemicals in India — ITO",
    description: "Temperature-controlled reefer trucks for propellants, sensitive chemicals, composite prepregs and resins, defence electro-optics, adhesives and aero-engine parts. Monitored, pan-India.",
    keywords: "reefer truck india, temperature controlled transport india, chemical reefer transport, prepreg transport, composite resin transport, propellant transport, defence electronics transport, aerospace reefer transport",
  },
  "tempos-city-vehicles": {
    title: "Tempo & City Delivery Vehicles in India | First & Last Mile — ITO",
    description: "Tempos and small commercial vehicles for first-mile pickup and last-mile delivery of spares, crated components and parcels inside Indian cities, tracked on one LR.",
    keywords: "tempo hire india, city delivery vehicle, last mile delivery india, first mile pickup, small truck hire, spares delivery",
  },
};

// Dedicated Aerospace page (/aerospace) — aero-engine manufacturers & MROs.
export const AEROSPACE = {
  title: "Moving India's aero engines, shock-free.",
  body:
    "Aero-engine makers, MROs and aerospace suppliers trust ITO to move engines, modules and flight-critical parts without a jolt. We use air-suspension trailers, engine transport stands, temperature-controlled reefers and priority air cargo, so every engine reaches the test cell, hangar or airbase exactly as it left your shop floor.",
  points: [
    "Complete aero engines on transport stands",
    "Engine modules, fan cases & turbine parts",
    "AOG & MRO engine movements",
    "Composites, prepregs & aerospace chemicals",
  ],
  capabilities: [
    { h: "Air-suspension trailers", p: "Pneumatic suspension cuts road shock and vibration, protecting bearings, blades and calibrated assemblies on every kilometre." },
    { h: "Shock & tilt monitoring", p: "Shock and tilt indicators can be fitted on request, with live GPS tracking and a dedicated movement coordinator." },
    { h: "Temperature-controlled reefers", p: "Reefers for cold-stored prepregs and resins, adhesives, sealants, coatings and engine components that need a set temperature." },
    { h: "AOG & priority air cargo", p: "Next-flight-out uplift for grounded aircraft, with surface pickup and delivery on one tracked Lorry Receipt." },
    { h: "Secure, sealed movement", p: "Sealed, direct, single-consignment loads with trained crews. Defence-grade discipline for military engine programmes." },
    { h: "Plant, test cell & airbase reach", p: "Pickup and delivery to engine plants, MRO hangars, test cells and airbases across India, including border regions." },
  ],
  cargo: [
    "Turbofan, turboshaft & turboprop engines",
    "Engine modules, fan cases & casings",
    "Turbine blades, discs & rotating parts",
    "Gearboxes, APUs & accessories",
    "Ground support & engine test equipment",
    "Composite parts, prepregs & resins",
  ],
};

export const AEROSPACE_FAQ = [
  { q: "Who transports aero engines by road in India?", a: "Indian Transport Organisation (ITO) moves aero engines, engine modules and flight-critical parts for engine makers, MROs and aerospace suppliers across India, on air-suspension trailers with live tracking, since 1972." },
  { q: "How do you protect an aero engine from vibration in transit?", a: "Engines travel on their transport stands, strapped on air-suspension trailers that cut road shock and vibration. Routes are planned to avoid rough stretches, speeds are controlled, and shock and tilt indicators can be fitted on request." },
  { q: "Can you handle AOG engine movements?", a: "Yes. For aircraft on ground we arrange priority road movement or next-flight-out domestic air cargo, with pickup and delivery on one tracked Lorry Receipt." },
  { q: "Do you move temperature-sensitive aerospace materials?", a: "Yes. Our reefers carry cold-stored composite prepregs and resins, adhesives, sealants, specialty coatings and engine components at a set, monitored temperature." },
  { q: "Do you serve defence and military engine programmes?", a: "Yes. We move military aero engines and parts sealed and escorted, with the same defence-grade documentation we use for tanks, drones and ammunition." },
];

// Per-fleet-vehicle FAQ (overrides the generic FAQs generated in FleetPage).
// The air-suspension entry directly targets high-intent search/AI queries.
export const FLEET_FAQ = {
  "explosive-van": [
    { q: "Who transports explosives and ammunition in India?", a: "Indian Transport Organisation operates licensed, fire-suppression fitted explosive vans for the compliant, escort-ready movement of ammunition and hazardous defence stores to any pincode in India, since 1972." },
    { q: "Are your explosive vans compliant with regulations?", a: "Yes — our explosive vans are licensed and fully compliant with Indian explosives and defence transport regulations, and are escort-ready for defence movements." },
    { q: "What cargo can move in an explosive van?", a: "Ammunition, explosives, Class-1 dangerous goods and other hazardous defence stores, moved sealed, permitted and escorted." },
  ],
  "low-bed-trailer": [
    { q: "What can a low-bed trailer carry?", a: "Tall, heavy plant — excavators, dozers, cranes, drilling rigs, transformers, reactors and armoured vehicles — kept low to the ground for stable, height-compliant transport." },
    { q: "What's the difference between low-bed and semi low-bed?", a: "A low-bed has the lowest deck for the tallest, heaviest single machines; a semi low-bed sits slightly higher and balances deck height with payload for versatile medium-heavy ODC." },
    { q: "Do you arrange permits and escorts for low-bed loads?", a: "Yes — route surveys, state permits, RTO clearances and pilot/police escorts are handled end to end by ITO." },
  ],
  "semi-low-bed-trailer": [
    { q: "When should I use a semi low-bed trailer?", a: "A semi low-bed is the versatile middle option — a balanced deck height and payload ideal for medium-heavy over-dimensional machinery that doesn't need the lowest low-bed deck." },
    { q: "What cargo suits a semi low-bed trailer?", a: "Construction equipment, DG sets, medium transformers, industrial packages and fabrications that are heavy and slightly over-dimensional." },
    { q: "Do you cover over-dimensional routes?", a: "Yes — we survey routes, secure multi-state permits and arrange escorts for over-dimensional semi low-bed movements across India." },
  ],
  "high-bed-trailer": [
    { q: "What is a high-bed (flatbed) trailer used for?", a: "High-bed flatbed trailers carry steel, structural fabrications, pipes, machinery and general full-load cargo that fits within standard height limits — the workhorse for industrial FTL." },
    { q: "What sizes of high-bed trailers do you run?", a: "A range of flatbed lengths and axle configurations sized to your load's weight and dimensions, from our 800+ owned fleet." },
    { q: "Can high-bed trailers carry ODC cargo?", a: "For loads within height limits, yes; for tall or very heavy pieces we switch you to low-bed, semi low-bed or modular trailers." },
  ],
  "modular-heavy-haul-trailer": [
    { q: "What can a modular heavy-haul trailer carry?", a: "The heaviest single-piece loads — large transformers, turbines, generators, reactors, pressure vessels, mill housings and refinery modules — on axle-line and self-propelled modular trailers." },
    { q: "How do modular trailers handle extreme weights?", a: "Hydraulic axle lines spread the load across many wheels and can be added, extended and steered, so extremely heavy and long pieces move safely and legally." },
    { q: "Do you plan the route and escorts for heavy-haul?", a: "Yes — every heavy-haul movement includes a route survey, permits, RTO clearances and pilot/police escorts, coordinated by ITO end to end." },
  ],
  "trucks-open-closed-body": [
    { q: "What truck sizes does ITO operate?", a: "12, 14, 18 and 22-tyre trucks in both open and closed (container) body, sized to your exact load, for full and part loads to every industrial corridor in India." },
    { q: "Do you handle both full and part loads?", a: "Yes — dedicated full truck loads and consolidated part loads, both with live Lorry Receipt tracking to any pincode." },
    { q: "Open body or closed body — which do I need?", a: "Closed body protects cargo from weather and pilferage (ideal for finished goods and spares); open body suits machinery, steel and cargo needing top/side loading." },
  ],
  "tempos-city-vehicles": [
    { q: "Do you offer city and last-mile delivery?", a: "Yes — small tempos and city vehicles handle first-mile pickups and last-mile deliveries to plant gates, depots and doorsteps across Indian cities." },
    { q: "What can a tempo carry?", a: "Smaller consignments, spares, crated components and parcels — the final leg that connects line-haul freight to its destination." },
    { q: "Are city movements tracked too?", a: "Yes — city and last-mile legs ride on the same Lorry Receipt tracking as our long-haul movements." },
  ],
  "reefer-vehicles": [
    { q: "Does ITO provide temperature-controlled reefer transport for defence and chemical cargo?", a: "Yes. ITO runs temperature-controlled reefer trucks in all sizes only for temperature-sensitive defence, aerospace and chemical cargo — propellants and sensitive chemicals, composite resins and prepregs, electro-optics, adhesives and coatings, and aero-engine components — to any pincode in India." },
    { q: "What temperature range do your reefer vehicles maintain?", a: "Our reefers hold set points from about +25°C down to −25°C depending on the vehicle, which covers controlled-room-temperature chemicals as well as frozen-storage prepregs and resins. The temperature is monitored for the whole trip. Share your material's datasheet range and we'll assign the right reefer." },
    { q: "What cargo moves in ITO's reefer trucks?", a: "Temperature-sensitive chemicals and propellants, cold-stored composite materials (resins and prepregs), defence electro-optics and sensitive electronics, adhesives, sealants and specialty coatings, and aero-engine components that need a controlled temperature." },
    { q: "Can you move prepregs and resins without breaking their out-life?", a: "Yes. Prepregs and resins are loaded straight from cold storage into a pre-cooled reefer and kept at the stated temperature until delivery, so out-time is not used up in transit." },
    { q: "Which reefer sizes are available?", a: "All sizes, from small reefers for urgent city deliveries to large reefer trucks for full-load line-haul across India, including movements to defence and aerospace sites." },
  ],
  "air-suspension-trailer": [
    { q: "Who is a leading air suspension trailer transporter in India?", a: "Indian Transport Organisation (ITO) is one of India's most trusted air-suspension trailer transporters, operating a large owned fleet since 1972. We move aero engines, CNC machines, transformers, electronics and defence electro-optics on air-suspension trailers to every pincode in India, with live tracking, permits and escorts arranged end to end." },
    { q: "What is an air suspension trailer used for?", a: "An air-suspension trailer uses pneumatic (air) suspension to cushion road shock and vibration, protecting fragile, calibration-critical and high-value cargo such as precision machinery, transformers, electronics and defence electro-optics for damage-free transport." },
    { q: "Why choose an air suspension trailer over a standard trailer?", a: "Standard leaf-spring trailers transmit far more road shock. Air-suspension trailers keep the deck stable and level, which is critical for delicate, high-value and calibration-sensitive equipment — reducing the risk of in-transit damage." },
    { q: "Which routes and cities do you cover with air suspension trailers?", a: "We operate air-suspension trailers pan-India to any pincode, including over-dimensional route surveys and multi-state permits, and proven high-altitude movements to Leh and Ladakh." },
  ],
};
